import React from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import moment from 'moment';
import { Chart, Bar } from "react-chartjs-2";
import { getSymbolFromCurrency } from "currency-symbol-map";
import * as OfferActions from "../../actions/OfferActions"
import * as SubscriptionActions from '../../actions/SubscriptionActions';
import * as InvoiceActions from "../../actions/InvoiceActions";
import { injectIntl, intlShape } from 'react-intl';
@connect(( store ) => {
  return {
    user: store.user.user,
    messages: store.messages.messages,
    offers: store.offer.offerList,
    subscriptions: store.subscription.subscriptionsList,
    currentCustomer: store.subscription.currentCustomer,
    //invoices: store.invoice.invoices,
    allFiles: store.invoice.allFiles
  }
} )
export default class Dashboard extends React.Component {
  static propTypes = {
    intl: intlShape
  };

  constructor() {
    super();
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(OfferActions.fetchOffers() );
    dispatch( SubscriptionActions.fetchSubscriptions() );
    dispatch( InvoiceActions.getInvoiceList());
    dispatch(InvoiceActions.findFiles())
  }

  downloadPdfInvoice = ( invoice ) => () => {
    this.props.dispatch( InvoiceActions.getPdfInvoiceByFileName( invoice.pdfFilename ) );
  };

  downloadPdf = (fileName) => () => {
    this.props.dispatch( InvoiceActions.getPdfContratByFileName( fileName ) );
  };


  render() {
    const { offers, invoices, currentCustomer, messages, history, subscriptions, allFiles} = this.props;
    const hasSubscription = !!subscriptions && subscriptions.length > 0;
    const {customerAccounts} = currentCustomer|| [];
    const latestDue = !!invoices && Math.max.apply( Math, invoices.map( invoice => invoice.invoiceDate ) );
    const lastInvoice = !!invoices && invoices.find( invoice => invoice.invoiceDate === latestDue ) || {};
    const oneInvoice = !!invoices && invoices.length === 1 && invoices.find( invoice => invoice );
    const codeSubSelected = window.location.hash.split("/")[3];
    return (
      <div id="dashboard" className="col-md-12 marginBottom " >
        <div className="col-md-8">
          <div className="stat-panel col-md-12">
            <h5 className="title stat-panel">{messages["common.label.dashboard"]}</h5>
          </div>
        </div>
        <div className="col-md-8">
        {hasSubscription &&
            subscriptions.map((subscription, index) => {
              const {services} = subscription || {};
              const foundSepaFile =  !!allFiles && allFiles.find(file => {
                const {name} = file;
                if (file.name === `${subscription.code}_AutorisationIBAN.pdf`) {
                  return file;
                };
              })
              const foundContratFile =  !!allFiles && allFiles.find(file => {
                const {name} = file;
                if (file.name === `${subscription.code}_Contract.pdf`) {
                  return file;
                };})
              const userAccountOfSub = subscription.userAccount || "";
              const customerAccount = !!customerAccounts && customerAccounts.find(customerAccount => {
                const billingAccount = customerAccount.billingAccount || {};
                const userAccount = billingAccount.userAccount || {};
                if (userAccountOfSub === userAccount.code) {
                  return customerAccount;
                }
              })
              const symbol = !!customerAccount && getSymbolFromCurrency( customerAccount.currency );
              const serviceCF = services.find(service =>  service.code === serviceInstanceCode) ||{};
              const {customFields} = serviceCF || [];
              const numKey =!!customFields &&  !!customFields.customField && ( customFields.customField ||[]).find( cf => cf.code === CF_numKey);
              const numCard = !!subscription && !!subscription.customFields &&    subscription.customFields.find(cf =>  cf.code === CF_numCard);
            //  const nameCGVorSGV = subscription.offerTemplate.code === fnacCode ? cgvName : cgsName;
              return (
                <div className="stat-panel col-md-12"  key={subscription.code.toString()} >
                  <p className="sousTitle title-of-box padding-top">
                    {messages["common.label.my.subscription"]}
                    <label className="yellow-color sousTitle"> &nbsp;&nbsp; {subscription.offerTemplate.name}
                    </label>
                  </p>
                  <div className="box-amount-wide col-md-12">
                    <div className="col-md-6">
                      <h5><label className="yellow-color labelClass">{messages["common.label.num.contrat"]}</label><b> : </b><label className="labelValue"> {subscription.code}</label></h5>
                      {!!numKey && numKey.stringValue ?
                        <h5><label className="yellow-color labelClass">{messages["common.label.num.key"]}</label><b> : </b><label className="labelValue">{!!numKey && numKey.stringValue}</label></h5>
                        :
                        <h5><label className="yellow-color labelClass">{messages["common.label.num.card"]}</label><b> : </b><label className="labelValue">{!!numCard && numCard.stringValue}</label></h5>
                      }
                      <div className="text-marginLeft">
                        <div className="text-marginTop">
                          <h5 className="strong title-of-box yellow-color">{messages["common.label.manage.subscription"]}</h5>
                        </div>
                        <div className="text-marginLeft">
                          {oneInvoice ?
                            <Link to={myInvoicesDetails_url.path + "/" + subscription.code}>
                              <li>> {messages["common.link.access.my.bills"]} </li></Link>
                            :
                            <Link to={myInvoicesDetails_url.path + "/" + subscription.code}>
                              <li>> {messages["common.link.access.my.bills"]} </li></Link>
                          }
                          <Link to={subscriptionDetails_url.path + "/" + subscription.code}><li>> {messages["common.link.see.my.services"]}</li></Link>
                          {(subscription.status === "TERMINATED" || subscription.status === "RESILIATED") ? null :
                            <Link to={manageSubscription_url.path + "/" + subscription.code}><li>> {messages["common.link.cancel.my.subscription"]}</li></Link>}
                          <Link to={mesCoordonnees_url.path}><li>> {messages["common.link.Update.my.payment.method"]}</li></Link>
                          <Link to={mesCoordonnees_url.path}><li>> {messages["common.link.update.my.details"]}</li></Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {!!lastInvoice && lastInvoice.amountWithTax &&
                        <div className="text-left">
                          <h5 className="yellow-color">{messages["common.label.what.i.must"]}</h5>
                          <div className="text-center yellow-color border" >
                            <p style={{ "fontSize": "20px" }}><strong> {(lastInvoice.amountWithTax || 0).toFixed(2)}{symbol} TTC </strong></p>
                            <button className="btn btn-theme-default">{messages["common.button.set.my.bill"]}</button>
                          </div>
                        </div>
                      }
                      <div className="text-marginLeft">
                        <b><h5 className="strong title-of-box yellow-color">{messages["common.label.my.documents"]}</h5></b>
                        <div className="text-marginLeft" >
                        {foundContratFile ?
                            <a onClick={this.downloadPdf(`${subscription.code}_Contract.pdf`)}>
                              <li>> {messages["common.link.download.my.contract"]}
                              </li>
                            </a>:
                            <a herf="">
                              <li style={{color: "#80808057"}}>> {messages["common.link.download.my.contract"]}
                              </li>
                            </a>
                          }
                          {oneInvoice ?
                            <a onClick={this.downloadPdfInvoice( invoice )}><li>> {messages["common.link.download.my.bills"]}</li></a>
                            :
                            <Link to={mesFactures_url.path}>
                              <li>> {messages["common.link.download.my.bills"]} </li></Link>
                            }
                            <a onClick={this.downloadPdf(`${subscription.code}_CGV.pdf` )}><li>> {messages["common.link.download.my.cgv"]} </li></a>
                            {foundSepaFile ?
                              <a onClick={this.downloadPdf(`${subscription.code}_AutorisationIBAN.pdf` )} target="_blank"><li>> {messages["common.link.download.my.SEPA.mandates"]} </li></a>
                              :
                              <a herf="" target="_blank"><li style={{color: "#80808057"}}>> {messages["common.link.download.my.SEPA.mandates"]} </li></a>
                            }
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>

                  )
                } )
              }
            </div>
            {hasSubscription &&
              <div className="stat-panel  col-md-4 padding-top">
                <p className="sousTitle title-of-box " style={{ "marginBottom": "5px" }}>
                  {messages["common.label.all.my.advices"]}  </p>
                <div className="text-center box-amount-wide" style={{ "marginTop": "3px" }}>
                    <div className="box-title text-left">
                      <p className="yellow-color">{messages["common.label.install.my.offer"]}</p>
                    </div>
                    <div className="text-center col-md-4" >
      							<img src="images/mesConseils/illustration.PNG" className="logo img-responsive"/>
      							</div>
                    <div className="text-left">
                      <p className="myConseils col-md-8"  style={{"paddingBottom": "20px","marginTop": "20px"}}>

                        {messages["common.label.secure.data"]}
                      </p>
                      <div className="text-left">
                    <i><a style={{"color": "gray","paddingTop": "12px"}} target="_blank" href="https://www.fnacserenite.com" rel="nofollow">{messages["common.link.my.advice.pack"]}</a></i>
                  </div>
                      <div className="text-center" style={{"marginTop": "20px"}} >
                        <Link to={mesConseils_url.path}>
                          <button className="btn btnn btn-theme-default ">{messages["common.label.my.advices"]}</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          )
        }
      }



// WEBPACK FOOTER //
// ./src/opencell/pages/client/Dashboard.jsx